"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxesWidget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const checkboxesWidget_style_1 = __importDefault(require("./checkboxesWidget.style"));
const CheckboxesWidget = ({ classes, schema: { title }, options, value }) => {
    const { enumOptions, inline } = options;
    const labelWrapperProps = {
        className: classes.labelWrapper,
        'data-is-inline': inline
    };
    const labelProps = {
        className: classes.label,
        'data-is-inline': inline
    };
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.title }, { children: title }), void 0),
            jsx_runtime_1.jsx("div", Object.assign({}, labelWrapperProps, { children: enumOptions.map(option => {
                    const checked = value.indexOf(option.value) !== -1;
                    return (checked && (jsx_runtime_1.jsxs("div", Object.assign({}, labelProps, { children: [jsx_runtime_1.jsx("div", { className: classes.emDash }, void 0),
                            jsx_runtime_1.jsx("span", { children: option.label }, void 0)] }), option.label)));
                }) }), void 0)] }, void 0));
};
exports.CheckboxesWidget = CheckboxesWidget;
exports.CheckboxesWidget.defaultProps = {
    options: {
        inline: false
    }
};
exports.default = react_jss_1.default(checkboxesWidget_style_1.default)(exports.CheckboxesWidget);
//# sourceMappingURL=index.js.map